import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './HeroSection.css';

const HeroSection = () => {
  const navigate = useNavigate();
  const [hoveredStat, setHoveredStat] = useState(null);

  const stats = [
    {
      number: '6',
      label: 'Critical Talent Dimensions',
      details: 'Our Right 6™ Framework addresses Recruiting, Retention, Recognition, Resilience, Readiness, and Relationships—the core pillars of organizational success.'
    },
    {
      number: '100%',
      label: 'Strategic Focus',
      details: 'Every engagement is tailored to your organization\'s unique needs, culture, and goals. No cookie-cutter solutions—only strategies that drive real results.'
    }
  ];

  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className="hero-badge">Strategic Talent Solutions</div>
        <h1 className="hero-title">
          Enterprise-Level<br/>
          Talent Solutions.<br/>
          <span>Built for Growing<br/>Organizations.</span>
        </h1>
        <p className="hero-subtitle">
          Strategic talent solutions for small and midsized businesses, franchises, civic organizations, and nonprofits that drive your mission forward.
        </p>
        <div className="hero-buttons">
          <button className="btn btn-primary" onClick={() => navigate('/assessment')}>
            Assess Your Organization
          </button>
          <button className="btn btn-secondary" onClick={() => window.open('https://form.jotform.com/260186646305054', '_blank')}>
            Get in Touch
          </button>
        </div>
      </div>
      <div className="hero-visual">
        <div className="hero-image-container">
          <img 
            src="https://customer-assets.emergentagent.com/job_collective-build-1/artifacts/i8zwnurb_iStock-2190572410.jpg" 
            alt="Team collaboration"
            className="hero-image"
          />
        </div>
        <div className="hero-stats">
          {stats.map((stat, index) => (
            <div 
              key={index}
              className={`stat-card ${hoveredStat === index ? 'stat-card-expanded' : ''}`}
              onMouseEnter={() => setHoveredStat(index)}
              onMouseLeave={() => setHoveredStat(null)}
            >
              <div className="stat-number">{stat.number}</div>
              <div className="stat-label">{stat.label}</div>
              <div className="stat-details">
                {stat.details}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;